export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_EDIT = 'edtInternidruh';
export const CRUMB_LABEL_LIST = 'fltInternidruh';
export const NAME = 'Internidruh';
